import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { PriceLabel as PriceLabelComponent } from 'src/components/offer/price/price-label';
import { CountryFlag } from 'src/components/country-flag/styles';

const priceSize = '16px';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1 0 auto;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacing025};

  ${media.smallOnly`
    height: auto;
  `}
`;

export const MediumUpFlex = styled.div`
  display: flex;
  align-items: center;

  ${media.smallOnly`
    display:none;
  `}
`;

export const MobileOnlyFlex = styled.div`
  display: flex;
  ${media.mediumUp`
    display: none;
  `}
`;

export const FirstRow = styled(Row)`
  align-items: center;
  gap: 0.5rem;

  ${CountryFlag} {
    margin-right: ${layout.measurements.spacing025};
  }
`;

export const SecondRow = styled(Row)`
  align-items: center;

  ${CountryFlag} {
    margin-right: ${layout.measurements.spacing025};
  }
`;

const ICON_SIZE_DESKTOP = 24;
const ICON_SIZE_MOBILE = 16;
const ICON_SIZE_STOCK_STATUS_MOBILE = 20;

export const PriceInfoElement = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};

  svg {
    width: ${ICON_SIZE_DESKTOP}px;
    height: ${ICON_SIZE_DESKTOP}px;

    ${media.smallOnly`
      width: ${ICON_SIZE_MOBILE}px;
      height: ${ICON_SIZE_MOBILE}px;
    `}
  }
`;

export const StockStatusWrapper = styled(PriceInfoElement)`
  ${media.smallOnly`
    svg {
      width: ${ICON_SIZE_STOCK_STATUS_MOBILE}px;
      height: ${ICON_SIZE_STOCK_STATUS_MOBILE}px;
    }
`}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PriceLabel = styled(PriceLabelComponent)`
  font-size: ${priceSize};
  line-height: 24px;
  text-align: right;
`;

export const StyledCaptionText = styled(CaptionText)`
  line-height: 1.25;
`;
